var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_vm._v("\n  App vue template\n  "),_c('MainView',{attrs:{"msg":"Welcome to Your Vue.js + TypeScript App"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }